/**
 * TAMWAJ — تعريب نصوص لا يملكها القالب
 *
 * زر الدفع المباشر يرسمه Shopify بنصّ من لغة المتجر لا من ملف ترجمة القالب،
 * فلا سبيل لتغييره من الثيم إلا بعد رسمه. المكان الدائم:
 *   الإعدادات ← اللغات ← تعديل الترجمات
 */
(function () {
  var MAP = {
    'Buy it now': 'اشتري الآن',
    'More payment options': 'خيارات دفع أخرى'
  };

  var FLAG = 'tamwajLabel';

  function run() {
    var nodes = document.querySelectorAll(
      '.shopify-payment-button__button, .shopify-payment-button__more-options, ' +
      '.shopify-payment-button__button *, .shopify-payment-button__more-options *'
    );

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length || el.dataset[FLAG]) continue;

      var t = (el.textContent || '').trim();
      var to = MAP[t];
      if (!to) continue;

      el.textContent = to;
      el.dataset[FLAG] = '1';
    }
  }

  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);

  // زر Shopify يُرسم بعد التحميل وقد يُعاد رسمه عند تبديل المتغيّر
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
